import Papa from 'papaparse';
import { ExportConfig, getCellValue, generateFileName, downloadBlob } from './types';

export const exportCsv = (config: ExportConfig): void => {
  const { title, columns, data, fileName } = config;

  const rows = data.map(row =>
    columns.reduce<Record<string, string>>((acc, col) => {
      acc[col.label] = getCellValue(row, col);
      return acc;
    }, {})
  );

  const csv = Papa.unparse(rows, {
    delimiter: ';',
    header: true,
  });

  const bom = '\uFEFF';
  const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, (fileName || generateFileName(title)) + '.csv');
};
